import React from "react";
import { LABEL_STYLE } from "../../lib/labels";

// Renders small version/content label chips. Pass either explicit `labels`/`content`
// arrays, or a `title` string to auto-detect version labels.
export const LabelChips = ({ labels = [], content = [], className = "" }) => {
  const all = [...(labels || []), ...(content || [])];
  if (all.length === 0) return null;
  return (
    <span className={`inline-flex flex-wrap gap-1 align-middle ${className}`} data-testid="label-chips">
      {all.map((l) => (
        <span
          key={l}
          className={`text-[8px] font-mono uppercase tracking-wider border rounded px-1 py-0.5 leading-none ${
            LABEL_STYLE[l] || "text-muted-foreground bg-white/5 border-border"
          }`}
        >
          {l}
        </span>
      ))}
    </span>
  );
};

export default LabelChips;
